module.exports = __webpack_public_path__ + "img/Delphinus.22f5136b.png";